import { TextInput } from 'Components/Shared';
import useTranslate from 'Hooks/useTranslate';
import { TUsersCreation } from './FormUsersCreation.container';
import FormUsersCreationLayout from './FormUsersCreationLayout';

type Props = {
  onCancel(): void;
  onSubmit(values: TUsersCreation): void;
  loading?: boolean;
  languages: ILanguage[];
  organizationName?: string;
};

const FormGuestUsersInvitation = ({
  onCancel,
  onSubmit,
  loading,
  languages,
  organizationName
}: Props) => {
  const ts = useTranslate();

  return (
    <FormUsersCreationLayout
      onCancel={onCancel}
      onSubmit={onSubmit}
      loading={loading}
      languages={languages}
      heading="component.modals.createUser.wizard.organizationHeading"
      subheading="component.modals.createUser.wizard.organizationSubheading"
      initialAccount="n/a"
    >
      <TextInput
        name="organization"
        variant="outlined"
        size="medium"
        label={ts('component.modals.createUser.labels.organizationName')}
        autoFocus
        value={organizationName ?? ''}
        disabled={true}
      />
    </FormUsersCreationLayout>
  );
};

export default FormGuestUsersInvitation;
